import Log from './log';
import { PUBLIC_NEXTDOOR_PIXEL_ID } from '$env/static/public';

export function initAndTrackNextdoorPageView(email?: string): void {
	const ndpFunction = window.ndp;
	if (!ndpFunction) return;

	try {
		ndpFunction('init', PUBLIC_NEXTDOOR_PIXEL_ID, email ? { user_email: email } : {});
		ndpFunction('track', 'PAGE_VIEW');
	} catch (e) {
		Log.exception(e);
	}
}

export function trackNextdoorConversion(orderId?: string): void {
	const ndpFunction = window.ndp;
	if (!ndpFunction) return;

	try {
		ndpFunction('track', 'CONVERSION', {}, orderId ? { order_id: orderId } : {});
	} catch (e) {
		Log.exception(e);
	}
}
